import { gql } from '@apollo/client';

const resourceFragment = gql`
  fragment resourceFragmentFields on Resource {
    Id
    Title
    Category
    Description
    Link
    CreatedDate
    ResourcePermissions
  }
`;

export default resourceFragment;
